/**
 * Scalapay cart drawer helpers.
 * Messaging comes from the native <scalapay-widget> in cart-drawer.liquid.
 * Also keeps the cart drawer open when interacting with Scalapay's learn-more
 * modal (portaled outside #CartDrawer — Impulse treats those clicks as "outside").
 */
(function () {
  const MOUNT_ID = 'ozn-scalapay-cart-widget';

  function getMount() {
    return document.getElementById(MOUNT_ID);
  }

  function setMountVisible(visible) {
    const mount = getMount();
    if (!mount) return;
    if (visible) {
      mount.removeAttribute('hidden');
    } else {
      mount.setAttribute('hidden', '');
    }
  }

  function syncFromCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    setMountVisible(cart.item_count > 0 && cart.total_price > 0);
  }

  function fetchAndSync() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then(syncFromCart)
      .catch(function () {});
  }

  function eventPath(evt) {
    if (typeof evt.composedPath === 'function') {
      return evt.composedPath();
    }
    const path = [];
    let el = evt.target;
    while (el) {
      path.push(el);
      el = el.parentNode || el.host;
    }
    return path;
  }

  function isScalapayNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.tagName === 'SCALAPAY-WIDGET') return true;
    if (node.id === MOUNT_ID) return true;
    if (node.id && /scalapay/i.test(node.id)) return true;
    const cls = typeof node.className === 'string' ? node.className : '';
    if (/scalapay|sp-exp5|sp-modal/i.test(cls)) return true;
    const testId = node.getAttribute && node.getAttribute('data-testid');
    if (testId && /scalapay/i.test(testId)) return true;
    return false;
  }

  function isFromScalapay(evt) {
    return eventPath(evt).some(isScalapayNode);
  }

  function isScalapayModalOpen() {
    const widgets = document.querySelectorAll('scalapay-widget');
    for (let i = 0; i < widgets.length; i++) {
      const root = widgets[i].shadowRoot;
      if (!root) continue;
      const dialog = root.querySelector('[role="dialog"], dialog, [aria-modal="true"]');
      if (!dialog) continue;
      const style = window.getComputedStyle(dialog);
      if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
        return true;
      }
      // fixed overlay wrappers used by Scalapay V5
      if (dialog.getClientRects().length > 0) return true;
    }
    return false;
  }

  // Bubble on document so Scalapay handles the click first, then we block
  // Impulse Drawers' window click listener (outside-click → close drawer).
  // Learn-more UI can sit outside #CartDrawer (shadow/portal), so also gate on modal open.
  document.addEventListener(
    'click',
    function (evt) {
      if (!isFromScalapay(evt) && !isScalapayModalOpen()) return;
      evt.stopPropagation();
    },
    false
  );

  // Escape closes Scalapay learn-more — don't let Impulse also close the drawer.
  document.addEventListener(
    'keyup',
    function (evt) {
      if (evt.key !== 'Escape' && evt.keyCode !== 27) return;
      if (!isFromScalapay(evt) && !isScalapayModalOpen()) return;
      evt.stopPropagation();
    },
    false
  );

  document.addEventListener('DOMContentLoaded', fetchAndSync);
  document.addEventListener('ajaxProduct:added', fetchAndSync);
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      syncFromCart(evt.detail.cart);
    } else {
      fetchAndSync();
    }
  });
})();
